module.exports = " <div> <div class=feature v-if=timeslot[occuringDay] id=\"feature-{{ feature.id }}\" :style=\"{ top: featureTop + unit, height: featureHeight + unit, 'z-index': feature.zindex }\" @click=handleTooltip($event)> <div class=feature-dot></div> <div class=feature-title>{{ feature.title }}</div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Feature.vue
// module id = 327
// module chunks = 2